let middle = [
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Belle Lin",
    title: "CIO 2023 Priorities: Cybersecurity - The Wall Street Journal",
    description: "CIO 2023 Priorities: Cybersecurity  The Wall Street Journal",
    url: "https://www.wsj.com/articles/cio-2023-priorities-cybersecurity-11672259635",
    urlToImage: "https://images.wsj.net/im-691043/social",
    publishedAt: "2022-12-30T12:00:00Z",
    content:
      "Technology executives in a recent CIO Journal end-of-year survey shared their priorities for 2023. While recruiting and retaining talent and leading through a tightening economy topped many to-dos, t… [+3171 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Meghan Bobrowsky",
    title:
      "Tesla Stock Is Headed for Its Biggest-Ever Annual Decline - The Wall Street Journal",
    description:
      "<ol><li>Tesla Stock Is Headed for Its Biggest-Ever Annual Decline  The Wall Street Journal\r\n</li><li>The vibes are off at Tesla  The Verge\r\n</li><li>Retail Investors and Hedge Funds Show Faith in Tesla (NASDAQ:TSLA) Stock  TipRanks\r\n</li><li>Elon Musk's compa…",
    url: "https://www.wsj.com/articles/tesla-stock-is-headed-for-its-biggest-ever-annual-decline-11672374248",
    urlToImage: "https://images.wsj.net/im-694429/social",
    publishedAt: "2022-12-30T10:30:00Z",
    content:
      "Tesla Inc. is poised Friday to close the worst year in the stocks history, having lost more than $700 billion in market valuation amid investor concerns about production disruptions, demand worries a… [+475 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Douglas Belkin",
    title:
      "The Impossible Decisions That Faced Those Trapped in the Buffalo Blizzard - The Wall Street Journal",
    description:
      "<ol><li>The Impossible Decisions That Faced Those Trapped in the Buffalo Blizzard  The Wall Street Journal\r\n</li><li>A Buffalo woman went out on Christmas Eve, telling her daughter she'd be right back. They found her body a few hundred feet from home  CNN\r\n</…",
    url: "https://www.wsj.com/articles/the-impossible-decisions-that-faced-those-trapped-in-the-buffalo-storm-11672318815",
    urlToImage: "https://images.wsj.net/im-693591/social",
    publishedAt: "2022-12-29T22:06:00Z",
    content:
      "On Friday afternoon, Abdul Sharifu left his house in Buffalo, N.Y., to go to the market to buy milk for his two young children. He hadnt gotten far when his car got stuck \r\nin one of the deadliest bl… [+451 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Liz Essley Whyte",
    title:
      "FDA Faulted for Working Improperly With Biogen Before Clearing Alzheimer’s Drug",
    description:
      "Aduhelm approval followed ‘atypical’ agency contacts with company, congressional report says",
    url: "https://www.wsj.com/articles/biogen-aduhelm-fda-approval-congressional-investigation-11672333482",
    urlToImage: "https://images.wsj.net/im-692208/social",
    publishedAt: "2022-12-29T18:00:00Z",
    content:
      "The U.S. Food and Drug Administration inappropriately collaborated with Biogen Inc. before approving its Alzheimers treatment Aduhelm in 2021, a new report from House Democrats concluded, as the agen… [+264 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Asa Fitch",
    title: "半導体不足が一転、供給過剰　PC・スマホ低迷で",
    description:
      "世界は今、半導体チップであふれている。 チップは2年間の旺盛な需要による世界的な不足から一転、供給過剰に陥っている。金利上昇や株価下落、リセッション（景気後退）懸念を受け、電子機器製品に対する消費者需要は減退している。チップ在庫の膨張は、より広範な経済の現状を反映している。小売業者は棚に商品があふ...",
    url: "https://jp.wsj.com/articles/chip-inventories-swell-as-consumers-buy-fewer-gadgets-11672206934",
    urlToImage: "https://images.wsj.net/im-692137/social",
    publishedAt: "2022-12-29T15:15:18Z",
    content:
      "2\r\n1\r\nCEO21202319-1110\r\nUBS1040\r\n2HP\r\nHPCEO2\r\n1211\r\nCEO10CPUAMD\r\nAMDCEO\r\nCFO11202211-20231\r\n202392023\r\n203\r\n11CFO23\r\n2030211341000\r\nCPU\r\n3101129CEO\r\n1520\r\nCopyright ©2022 Dow Jones &amp; Company, Inc… [+54 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Nina Trentmann",
    title:
      "Qualcomm CFO Trims Operating Expenses as Industry Faces Down High Inventories - The Wall Street Journal",
    description:
      "Akash Palkhiwala expects the excess stock to be worked off over a couple of quarters, and talks about the benefits of higher interest rates on the company’s cash holdings",
    url: "https://www.wsj.com/articles/qualcomm-cfo-trims-operating-expenses-as-industry-faces-down-high-inventories-11671731136",
    urlToImage: "https://images.wsj.net/im-690644/social",
    publishedAt: "2022-12-29T14:00:00Z",
    content:
      "Qualcomm Inc.,\r\nthe San Diego-based technology company that sells chips, software and other products, last month slashed its forecast for smartphone shipments again and offered a gloomy assessment of… [+4970 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "wsj",
    title:
      "Epic Dollar Rally Goes Into Reverse -- and Investors Expect Further Declines...",
    description: "WSJ Dollar Index on track for biggest yearly gain since 2014",
    url: "https://www.wsj.com/articles/an-epic-dollar-rally-goes-into-reverseand-investors-expect-further-declines-11672307459",
    urlToImage: "https://images.wsj.net/im-693339/social",
    publishedAt: "2022-12-29T13:00:03Z",
    content:
      "An Epic Dollar Rally Goes Into Reverse—and Investors Expect Further DeclinesThe U.S. dollar’s rally in 2022 gave the world a reminder of the currency’s ability to inflict pain on the global economy. … [+1350 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Ann M. Simmons, Krishna Pokharel",
    title:
      "Russian Politician and Businessman Dies After Falling From Hotel Roof in India - The Wall Street Journal",
    description:
      "<ol><li>Russian Politician and Businessman Dies After Falling From Hotel Roof in India  The Wall Street Journal\r\n</li><li>Mysterious circumstances surround deaths of these Russian tycoons  CNN\r\n</li><li>Full List of Russians Who Fell to Their Deaths This Year…",
    url: "https://www.wsj.com/articles/russian-politician-and-businessman-dies-after-falling-from-hotel-roof-in-india-11672318229",
    urlToImage: "https://images.wsj.net/im-693917/social",
    publishedAt: "2022-12-29T12:50:00Z",
    content:
      "MOSCOWA Russian politician and businessman died after falling from the roof of a hotel in India on Christmas Eve, police said, two days after a companion succumbed to a heart attack and months after … [+395 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Yang Jie",
    title: "Apple Production in China Begins to Catch Up Despite Covid-19 Woes",
    description:
      "Main facility recovers to about 70% of capacity and wait times for iPhone Pro models shorten",
    url: "https://www.wsj.com/articles/apple-production-in-china-begins-to-catch-up-despite-covid-19-woes-11672315005",
    urlToImage: "https://images.wsj.net/im-693926/social",
    publishedAt: "2022-12-29T12:01:46Z",
    content:
      "Covid-19 issues in China are still hampering manufacturing of Apple Inc.s iPhone, but production is beginning to catch up to demand for the more-expensive Pro models, according to analysts and people… [+413 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Alex Leary",
    title:
      "Jan. 6 Panel Withdraws Subpoena Issued to Trump - The Wall Street Journal",
    description:
      "<ol><li>Jan. 6 Panel Withdraws Subpoena Issued to Trump  The Wall Street Journal\r\n</li><li>January 6 committee withdraws Trump subpoena: 'They knew I did nothing wrong'  Fox News\r\n</li><li>Donald Trump's Dispatches From the Bunker  The Bulwark\r\n</li><li>Jan. …",
    url: "https://www.wsj.com/articles/jan-6-panel-withdraws-subpoena-issued-to-trump-11672282769",
    urlToImage: "https://images.wsj.net/im-693837/social",
    publishedAt: "2022-12-29T02:59:00Z",
    content:
      "WASHINGTONThe House select committee \r\ninvestigating the Jan. 6, 2021, Capitol riot withdrew a subpoena it issued in October to Donald Trump as the investigation has wrapped up and Republicans are se… [+432 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "The Editorial Board",
    title:
      "Pete Buttigieg, Air Traffic Controller - WSJ - The Wall Street Journal",
    description:
      "<ol><li>Pete Buttigieg, Air Traffic Controller - WSJ  The Wall Street Journal\r\n</li><li>Southwest will 'fix' this travel nightmare, not Pete Buttigieg: Duffy  Fox Business\r\n</li><li>Was Pete Buttigieg Asleep at the Switch for Southwest Airlines’ Holiday Implo…",
    url: "https://www.wsj.com/articles/pete-buttigieg-air-traffic-controller-southwest-airlines-cancellations-bob-jordan-elizabeth-warren-11672267784",
    urlToImage: "https://images.wsj.net/im-693800/social",
    publishedAt: "2022-12-29T02:46:00Z",
    content:
      "The scheduling meltdown at Southwest Airlines is one for the business record books, and the carrier will pay a price for months or years in damaged reputation. The only worse result for seething pass… [+317 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Merrie Spaeth",
    title: "Is George Santos Believable-ish? - WSJ - The Wall Street Journal",
    description:
      "<ol><li>Is George Santos Believable-ish? - WSJ  The Wall Street Journal\r\n</li><li>Federal prosecutors are investigating Rep.-elect George Santos' finances  CNN\r\n</li><li>George Santos is presidential material | Sheneman  NJ.com\r\n</li><li>George Santos Is Not …",
    url: "https://www.wsj.com/articles/is-george-santos-believable-ish-embellishment-politics-new-york-congress-religion-goldman-sachs-citigroup-11672267119",
    urlToImage: "https://images.wsj.net/im-693376/social",
    publishedAt: "2022-12-28T23:39:00Z",
    content:
      "Is there an award for most denials in a statement? If so, Rep.-elect George Santos (R., N.Y.) is a leading contender. A series of press reports raised questions about claims Mr. Santos, 34, made duri… [+711 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "wsj",
    title: "Inflation Takes Biggest Bite From Middle Class...",
    description:
      "Purchasing power from paychecks fell for middle-income households in 2022, while rising for those at the bottom and top.",
    url: "https://www.wsj.com/articles/inflation-takes-biggest-bite-from-middle-income-households-11672246653",
    urlToImage: "https://images.wsj.net/im-692959/social",
    publishedAt: "2022-12-28T23:00:03Z",
    content:
      "Inflation Takes Biggest Bite From Middle-Income HouseholdsInflation is often called a tax on the poor, but this time it’s hit middle-income households the hardest. Many low-income households, benefit… [+814 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Alison Sider",
    title: "How Southwest Airlines melted down",
    description:
      "Airline executives and labor leaders point to inadequate technology systems as one reason why a brutal winter storm turned into a debacle",
    url: "https://www.wsj.com/articles/southwest-airlines-melting-down-flights-cancelled-11672257523",
    urlToImage: "https://images.wsj.net/im-693637/social",
    publishedAt: "2022-12-28T20:50:52Z",
    content:
      "When Southwest Airlines Co. reassigns crews after flight disruptions, it typically relies on a system called SkySolver. This Christmas, SkySolver not only didnt solve much, it also \r\nhelped create th… [+421 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Jared Malsin",
    title: "Turkey, Syria Defense Ministers Meet in Moscow...",
    description:
      "Turkey, Syria Defense Ministers Meet in Moscow...\r\n\n \n \n \n (Second column, 3rd story, link)\r\n\n \r\n\n \r\n\n \n Related stories:WAR? Tension soars as Kosovo shuts main border crossing with Serbia...\r\nPUTIN GENERAL MYSTERIOUSLY DIES...\r\nRussiaChina rehearse attacking…",
    url: "https://www.wsj.com/articles/turkey-syria-defense-ministers-meet-in-moscow-11672255686",
    urlToImage: "https://images.wsj.net/im-693625/social",
    publishedAt: "2022-12-28T20:31:37Z",
    content:
      "ISTANBULTurkeys defense minister and intelligence chief held talks with their Syrian counterparts in Moscow on Wednesday, the first formal, high-level meeting between the two Middle East governments … [+394 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Lindsay Ellis",
    title: "Why So Many Accountants Quitting...",
    description:
      "Why So Many Accountants Quitting...\r\n\n \n \n \n (Third column, 4th story, link)",
    url: "https://www.wsj.com/articles/why-so-many-accountants-are-quitting-11672236016",
    urlToImage: "https://images.wsj.net/im-690045/social",
    publishedAt: "2022-12-28T19:40:38Z",
    content:
      "More than 300,000 U.S. accountants and auditors have left their jobs in the past two years, a 17% decline, and the dwindling number of college students coming into the field cant fill the gap. \r\nThe … [+409 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Dean Seal",
    title: "Airlines Cap Fares as Southwest Cancellations Continue",
    description:
      "American, Delta and United said they would keep prices in check and make flights available to stranded travelers",
    url: "https://www.wsj.com/articles/airlines-cap-fares-as-southwest-cancellations-continue-11672246329",
    urlToImage: "https://images.wsj.net/im-693452/social",
    publishedAt: "2022-12-28T16:56:46Z",
    content:
      "Rival airlines have capped fares in some cities in response to an influx of last-minute bookings made after Southwest Airlines Co.\r\nscrapped thousands of flights during the past week.Southwest cancel… [+429 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "wsj",
    title: "House Bans TIKTOK on Phones of Representatives and Staff...",
    description:
      "Action follows new law banning the app in executive branch agencies",
    url: "https://www.wsj.com/articles/u-s-house-bans-tiktok-on-phones-of-representatives-and-staff-11672242774",
    urlToImage: "https://images.wsj.net/im-693377/social",
    publishedAt: "2022-12-28T16:00:02Z",
    content:
      "U.S. House Bans TikTok on Phones of Representatives and StaffWASHINGTON—The U.S. House of Representatives is banning TikTok on all House-managed devices, moving to get in sync with a new law banning … [+1351 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Sebastian Herrera",
    title:
      "Unionization Stalls at Amazon as Turnover, Company Efforts Stymie Activism",
    description:
      "Organizing at companies is set to continue but may proceed more slowly and take years to play out, labor researchers say",
    url: "https://www.wsj.com/articles/unionization-stalls-at-amazon-as-turnover-company-efforts-stymie-activism-11672236158",
    urlToImage: "https://images.wsj.net/im-688898/social",
    publishedAt: "2022-12-28T14:06:51Z",
    content:
      "When thousands of workers at an Amazon.com Inc. warehouse in New York \r\nvoted to unionize earlier this year, Nannette Plascencia thought her facility east of Los Angeles could be among those to vote … [+326 chars]",
  },
  {
    source: { id: "the-wall-street-journal", name: "The Wall Street Journal" },
    author: "Raffaele Huang",
    title:
      "China Approves Foreign Videogames in Latest Breather for Tech Giants - The Wall Street Journal",
    description:
      "Beijing regulators approve ‘Pokémon’ and ‘Game of Thrones’ titles, ending a suspension on foreign videogames dating to June 2021",
    url: "https://www.wsj.com/articles/china-approves-foreign-videogames-in-latest-breather-for-tech-giants-11672228919",
    urlToImage: "https://images.wsj.net/im-693293/social",
    publishedAt: "2022-12-28T12:02:00Z",
    content:
      "SINGAPOREChina has resumed granting publishing approvals for foreign videogames, ending a halt stretching back to June 2021 and removing a source of uncertainty for the countrys once-flourishing vide… [+342 chars]",
  },
];
export default middle;